<div class="region-feature">
    <fieldset [ngModelGroup]="groupName" class="flex-row center-align">
        <div class="flex-column grow space-right-30">
            <label class="label-title" [i18n]="[{target: 'innerHTML', key: labelNode + '.label'}]"></label>
            <span class="dspl-block inner-space-top-8">
                <i class="fa fa-info-circle space-right-5"></i>
                <span [i18n]="[{target: 'innerHTML', key: labelNode + '.description'}]"></span>
            </span>
        </div>

        <div class="region-feature-toggle">
            <app-switcher class="space-right-25"
                [labelKey]="'regions.form.features.available.label'"
                          [(ngModel)]="available"
                          [name]="groupName + 'Available'"
                          (change)="availableChanged()">
            </app-switcher>
            <app-switcher [labelKey]="'regions.form.features.forced.label'"
                          [(ngModel)]="forced"
                          [name]="groupName + 'Forced'"
                          (change)="forcedChanged()">
            </app-switcher>
        </div>
    </fieldset>
</div>

<ng-template #disableModal let-c="close" let-d="dismiss">
    <span [i18n]="[{target: 'innerHTML', key: 'regions.form.modals.disable-feature.content'}]"></span>
</ng-template>
